<template>
  <!-- 申请表详情 -->
  <div
    class="pop-room pop-create-detail"
    :class="{
      'material-detail-pop': projectTable.tableType == '51',
    }"
    v-if="projectTable.status"
    :style="'height:' + popHeight + 'px;padding-bottom:20px;'"
  >
    <a
      href="javascript:;"
      v-if="isShowCloseIcon != 'false'"
      @click="closeProjectInfo()"
      class="iconfont icon-close"
    ></a>

    <div v-if="form">
      <!-- 印章使用详情增加权限限制 -->
      <div
        class="pop-cont-denied"
        v-if="
          !backRole('SM_5') &&
          (projectTable.tableType == '0' || projectTable.tableType == '1') &&
          !(
            form.flow.creator.id == nowUserData.id ||
            isApprovalUser(form.flow.approvals)
          )
        "
      >
        权限不足，无法查看审批详情
      </div>

      <div class="pop-cont" v-else>
        <!-- 工程、合同、材料、采购 -->
        <div class="pop-scroll" v-if="project || isHasData">
          <h3 class="title">
            <!-- 是否微型工程 -->
            <span v-if="project">
              <span class="approval-type at3" v-if="project.type == 3"
                >微型工程(B类)</span
              >
              <span class="approval-type at3" v-else-if="project.type == 4"
                >原水微型工程(B类)</span
              >
              <span class="approval-type at3" v-else-if="project.wxType == 'A'"
                >微型工程(A类)</span
              >
              <span class="approval-type at2" v-else> </span>
            </span>
            <!-- title -->
            <span
              v-if="
                projectTable.tableType == 4 &&
                (project.type == 3 || project.type == 4)
              "
            >
              预算（招标控制价）审批
            </span>
            <span
              v-else-if="
                projectTable.tableType == 40 && flow && flow.flowsourceType == 6
              "
            >
              原水公司资金使用申请表
            </span>
            <span v-else>
              {{ approvalTitle["key_" + projectTable.tableType] }}
            </span>

            <div
              v-if="
                isGc() &&
                form.flow.flowsource != '0' &&
                form.flow.flowsource != '1'
              "
              style="display: inline-block"
            >
              <!-- 是否线下 -->
              <p v-if="isMobile">
                <span
                  class="underline-tip"
                  style="margin: 0"
                  v-if="form.underLine != '0'"
                >
                  *该审批已线下通过
                </span>
              </p>
              <p v-else style="display: inline-block">
                <span class="underline-tip" v-if="form.underLine != '0'">
                  <该审批已线下通过>
                </span>
              </p>
            </div>

            <span style="margin-left: 10px; position: relative; top: -3px">
              <a
                v-if="!isMobile && isGc()"
                :href="
                  baseURL +
                  '/export/' +
                  form.flow.applyId +
                  '/' +
                  form.flow.flowsource
                "
                target="_blank"
              >
                <!-- 负责人、审批人、管理员可以下载 -->
                <!-- SYSTEM_2 单独设置的下载权限 -->
                <el-button
                  v-if="
                    (project.leader && project.leader.id == nowUserData.id) ||
                    isApprovalUser(form.flow.approvals) ||
                    isSystemAdmin() ||
                    backRole('SYSTEM_2')
                  "
                  type="success"
                  icon="el-icon-download"
                  size="mini"
                  >表格下载</el-button
                >
              </a>

              <!-- 专门材料领用单 -->
              <a
                v-if="!isMobile && !isGc() && projectTable.tableType != '130'"
                :href="
                  baseURL +
                  '/export/' +
                  form.flow.applyId +
                  '/' +
                  form.flow.flowsource
                "
                target="_blank"
              >
                <!-- 负责人、审批人、管理员可以下载 -->
                <!-- SYSTEM_2 单独设置的下载权限 -->
                <el-button
                  v-if="
                    (form.leader && form.leader.id == nowUserData.id) ||
                    isApprovalUser(form.flow.approvals) ||
                    isSystemAdmin() ||
                    backRole('SYSTEM_2')
                  "
                  type="success"
                  icon="el-icon-download"
                  size="mini"
                  >表格下载</el-button
                >
              </a>

              <!-- 打印 -->
              <el-button
                v-if="isPrint()"
                @click="printShow()"
                type="primary"
                icon="el-icon-printer"
                size="mini"
                >打印格式
              </el-button>
            </span>
          </h3>

          <span v-if="isGc()">
            <a
              v-if="form && !isMobile && form.project && form.project.id"
              class="right-top-btn"
              target="_blank"
              :href="'/Project/Detail/' + form.project.id"
            >
              <el-button type="primary" size="mini" plain
                >点击前往工程项目详情页</el-button
              >
            </a>
            <a
              v-else-if="form && !isMobile && form.contractVO"
              class="right-top-btn"
              target="_blank"
              :href="'/Contract/Detail/' + form.contractVO.id"
            >
              <el-button type="primary" size="mini" plain
                >点击前往合同详情页</el-button
              >
            </a>
          </span>

          <div class="project-info-box">
            <!-- 会议申请 -->
            <meeting-apply
              v-if="projectTable.tableType == '130'"
              :userData="userData"
              :form="form"
            >
            </meeting-apply>

            <!-- 供应商准入 -->
            <purchase-supplier
              v-if="projectTable.tableType == '120'"
              :userData="userData"
              :form="form"
            >
            </purchase-supplier>

            <!-- 固定资产 -->
            <asset-allot
              v-if="projectTable.tableType == '111'"
              :userData="userData"
              :form="form"
            >
            </asset-allot>
            <asset-handle
              v-if="projectTable.tableType == '110'"
              :userData="userData"
              :form="form"
            >
            </asset-handle>

            <!-- 车辆 -->
            <car-apply-detail
              v-if="isCarApply()"
              :userData="userData"
              :form="form"
            ></car-apply-detail>

            <!-- 易耗品 -->
            <consumable-apply-detail
              v-if="projectTable.tableType == '60'"
              :userData="userData"
              :form="form"
            >
            </consumable-apply-detail>
            <consumable-plan-apply-detail
              v-if="projectTable.tableType == '61'"
              :userData="userData"
              :form="form"
            >
            </consumable-plan-apply-detail>
            <consumable-in
              v-if="projectTable.tableType == '62'"
              :userData="userData"
              :form="form"
            >
            </consumable-in>
            <consumable-use
              v-if="projectTable.tableType == '63'"
              :userData="userData"
              :form="form"
            >
            </consumable-use>
            <consumable-back
              v-if="projectTable.tableType == '64'"
              :userData="userData"
              :form="form"
            >
            </consumable-back>

            <!-- 考勤未签到 kqApply -->
            <kq-apply
              v-if="projectTable.tableType == '104'"
              :userData="userData"
              :form="form"
            >
            </kq-apply>
            <!-- 废弃项目/合同 -->
            <discard-apply
              v-if="projectTable.tableType == '103'"
              :project="project"
              :userData="userData"
              :form="form"
            >
            </discard-apply>
            <!-- 通用审批 commonApply -->
            <common-apply
              v-if="projectTable.tableType == '100'"
              :userData="userData"
              :form="form"
            >
            </common-apply>
            <!-- 请假审批 vacationApply -->
            <vacation-apply
              v-if="projectTable.tableType == '101'"
              :userData="userData"
              :form="form"
            >
            </vacation-apply>
            <!-- 人员调动审批 transferApply -->
            <transfer-apply
              v-if="projectTable.tableType == '102'"
              :userData="userData"
              :form="form"
            >
            </transfer-apply>

            <!-- 采购相关 -->
            <purchase-apply-detail
              v-if="projectTable.tableType == '70'"
              :userData="userData"
              :form="form"
            >
            </purchase-apply-detail>
            <purchase-record-detail
              v-if="projectTable.tableType == '71'"
              :userData="userData"
              :form="form"
            >
            </purchase-record-detail>

            <!-- 材料领用 -->
            <material-use-detail
              v-if="projectTable.tableType == '50'"
              :userData="userData"
              :form="form"
            >
            </material-use-detail>
            <!-- 材料退库 -->
            <material-back-detail
              v-if="projectTable.tableType == '51'"
              :userData="userData"
              :form="form"
            >
            </material-back-detail>

            <!-- InfoCreate -->
            <info-create
              v-if="
                form.createType == 0 ||
                form.createType == 1 ||
                form.createType == 2 ||
                form.createType == 3 ||
                form.createType == 4 ||
                form.createType == 5
              "
              :projectArr="projectArr"
              :project="project"
              :teamArr="teamArr"
              :userData="userData"
              :form="form"
            >
            </info-create>

            <!-- InfoInvite -->
            <info-invite
              v-if="
                form.inviteType == 0 ||
                form.inviteType == 1 ||
                form.inviteType == 2
              "
              :project="project"
              :userData="userData"
              :form="form"
            ></info-invite>
            <!-- InfoBudget -->
            <info-budget
              v-if="form.inviteType == 3 || form.inviteType == 4"
              :project="project"
              :userData="userData"
              :form="form"
            ></info-budget>

            <!-- InfoInviteApproval -->
            <info-invite-approval
              v-if="
                projectTable.tableType == '10' || projectTable.tableType == '30'
              "
              :project="project"
              :userData="userData"
              :form="form"
            ></info-invite-approval>
            <!-- InfoContractApproval -->
            <info-contract-approval
              v-if="
                projectTable.tableType == '11' || projectTable.tableType == '31'
              "
              :project="project"
              :userData="userData"
              :form="form"
            ></info-contract-approval>

            <!-- 印章相关审批 -->
            <info-seal
              v-if="
                projectTable.tableType == '0' || projectTable.tableType == '1'
              "
              :form="form"
              :userData="userData"
              :sealArr="sealArr"
            ></info-seal>

            <!-- 支付审批info -->
            <info-create-pay
              v-if="
                projectTable.tableType == '14' ||
                projectTable.tableType == '32' ||
                projectTable.tableType == '40'
              "
              :form="form"
              :userData="userData"
            ></info-create-pay>
          </div>

          <el-form ref="form" :model="form" label-width="140px" class="form">
            <!-- 付款审核意见单 -->
            <create-money-approval-info
              v-if="
                projectTable.tableType == '5' || projectTable.tableType == '33'
              "
              :project="project"
              :userData="userData"
              :formByFather="form"
              :operationType="'show'"
            >
            </create-money-approval-info>

            <!-- <create-pay-approval :project="project"
              :userData="userData" :formByFather="form" :operationType="'show'"></create-pay-approval> -->

            <create-update-time
              v-if="projectTable.tableType == '13'"
              :project="project"
              :userData="userData"
              :formByFather="form"
              :operationType="'show'"
            ></create-update-time>

            <div class="pop-mask"></div>
          </el-form>

          <!-- <div class="tip" style="margin:20px 0 0 40px">
          * 本次审批的附件
          <span style="color:#d93c37;font-size:12px;margin-left:6px;">(附件可在审批进行中动态修改)</span>
        </div> -->
          <div
            v-if="projectTable.tableType != '130'"
            class="clear pi-attach-arr"
            style="margin-top: 0"
          >
            <!-- form.project判断是否是工程项目详情、或工程合同详情 -->
            <!-- else 有合同详情的就是独立合同 -->
            <attachments
              :projectId="form.project ? form.project.id : ''"
              :contractId="form.project ? '' : project ? project.id : ''"
              :arr="attachmentArr"
              :type="getAttachmentsType()"
              :form="form"
              :flowId="flowId"
              :flowUser="userData"
              :approvalUserData="approvalUserData"
            >
            </attachments>
          </div>
          <!-- <div class="clear pi-attach-arr" style="margin-top:0;">
            <attachments :projectId="form.project?form.project.id:''" :contractId="form.contractVO?project.id:''" :arr="attachmentArr"
              :type='getAttachmentsType()' :form="form" :flowId="flowId" :flowUser="userData" :approvalUserData="approvalUserData"></attachments>
          </div> -->

          <!-- <div class="tip" style="margin:20px 0 0 40px" v-if="otherAttachmentArr.length">
          * 更多其他附件
          <span style="color:#d93c37;font-size:12px;margin-left:6px;">(已经通过的审批的相关附件)</span>
        </div>
        <div class="clear pi-attach-arr" style="margin-top:0;" v-if="otherAttachmentArr.length">
          <div class="appendix">
            <div class="item" v-for="item,i in otherAttachmentArr">
              <i class="iconfont icon-link"></i>
              <file-link :item="item"></file-link>
              <a :href="item.fileUrl" style="margin-left:5px;" target="_blank">
                <el-button size="mini">下载</el-button>
              </a>
            </div>
          </div>
        </div> -->

          <!-- 采购审批中显示关联合同/关联工程 -->
          <section
            v-if="
              (projectTable.tableType == '70' ||
                projectTable.tableType == '71') &&
              form.projectIds
            "
          >
            <div class="tip" style="margin: 20px 0 0 40px">* 关联工程</div>
            <div class="project-list" style="padding: 0 0 0 40px">
              <p
                style="text-indent: 1em"
                v-for="(item, i) in form.projectIds.split(',')"
              >
                <router-link
                  class="link"
                  target="_blank"
                  :to="'/Project/Detail/' + item"
                >
                  <span class="iconfont icon-link"></span>
                  {{ form.projectNames.split(",")[i] }}
                </router-link>
              </p>
            </div>
          </section>
          <section
            v-if="projectTable.tableType == '70' && contractList.length > 0"
          >
            <div class="tip" style="margin: 20px 0 0 40px">* 关联合同</div>
            <div class="contract-list" style="padding: 0 0 0 40px">
              <!-- contractList -->
              <el-table :data="contractList" border style="width: 100%">
                <el-table-column prop="htbh" label="合同编号" width="100px">
                </el-table-column>
                <el-table-column label="合同名称">
                  <template slot-scope="scope">
                    <router-link
                      :to="'/Contract/Detail/' + scope.row.id"
                      class="link"
                      target="_blank"
                    >
                      {{ scope.row.name }}</router-link
                    >
                  </template>
                </el-table-column>
                <el-table-column prop="htjk" label="合同金额(元)" width="90px">
                </el-table-column>
                <el-table-column prop="status" label="状态" width="80px">
                </el-table-column>
                <el-table-column label="项目负责人" width="150px">
                  <template slot-scope="scope">
                    <user-info :userData="scope.row.leader"></user-info>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="60px">
                  <template slot-scope="scope">
                    <router-link
                      target="_blank"
                      :to="'/Contract/Detail/' + scope.row.id"
                    >
                      <el-button plain size="mini">详情</el-button>
                    </router-link>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </section>

          <div class="tip" style="margin: 20px 0 0 40px">* 意见与审批</div>
          <div class="approval-list">
            <div
              class="approval-item"
              v-for="(approval, i) in approvalUserData"
            >
              <span v-if="approval.status">
                {{ approval.user.department }}
                <span class="name">{{ approval.user.name }}</span> 在
                {{ approval.approvalTime }} 审批
                {{ approval.lastModifyTime }}
                <span class="status">{{ approval.status }}</span
                >，审核意见：“{{ approval.remark ? approval.remark : "无" }}”。
              </span>
              <span v-else>
                {{ approval.user.department }}
                <span class="name">{{ approval.user.name }}</span>
                <span class="status">暂未审批</span>
              </span>
            </div>
          </div>

          <!-- 移动H5 -->
          <el-button
            v-if="
              isMobile && form.flow.isCurUser && !form.flow.isCurUserArrpoval
            "
            style="margin-top: 0.35rem; width: 100%"
            @click="arpproval()"
            type="primary"
            >立即审批</el-button
          >
          <!-- web -->
          <!-- <el-button v-if="!isMobile && form.flow.isCurUser && !form.flow.isCurUserArrpoval"
            style="margin: 20px 0 0 60px" @click="arpproval()" type="primary">立即审批</el-button> -->
          <!-- 提醒 -->
          <el-button
            v-if="
              form.flow.status == '进行中' &&
              (form.flow.isCurUser || form.flow.creator.id == nowUserData.id)
            "
            style="margin: 20px 0 0 60px"
            :disabled="btnDisabled"
            :loading="btnLoading"
            @click="FlowRemind()"
            size="small"
            type="success"
          >
            提醒领导尽快审批</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

// 供应商准入
import purchaseSupplier from "./projectinfo/purchaseSupplierApply";
import meetingApply from "./projectinfo/meetingApply";

// 资产
import assetAllot from "@/page/asset/components/allot";
import assetHandle from "@/page/asset/components/handle";

// 车辆
import carApplyDetail from "@/page/car/components/applyDetail";

// 易耗品
import consumableApplyDetail from "@/page/consumable/components/applyDetail";
import consumablePlanApplyDetail from "@/page/consumable/components/planApplyDetail";
import consumableIn from "@/page/consumable/components/in";
import consumableUse from "@/page/consumable/components/use";
import consumableBack from "@/page/consumable/components/back";

// 通用审批
import commonApply from "./projectinfo/commonApply";
// 废弃项目/合同
import discardApply from "./projectinfo/discardApply";
// 请假审批
import vacationApply from "./projectinfo/vacationApply";
// 人员调动审批
import transferApply from "./projectinfo/transferApply";
// 考勤未签到审批
import kqApply from "./projectinfo/kqApply";

// 采购相关
import purchaseApplyDetail from "@/page/purchase/components/purchaseApplyDetail";
import purchaseRecordDetail from "@/page/purchase/components/purchaseRecordDetail";

// 仓库材料
import materialUseDetail from "@/page/storage/components/materialUseDetail";
import materialBackDetail from "@/page/storage/components/materialBackDetail";

import createMoneyApprovalInfo from "../form/createMoneyApprovalInfo";
import createMoneyPayApproval from "../form/createMoneyPayApproval";
import createSettlementPayApproval from "../form/createSettlementPayApproval";
import createPayApproval from "../form/createPayApproval";
import createTechContact from "../form/createTechContact";

import createUpdateTime from "../form/createUpdateTime";

import Attachments from "@/components/Attachments";
import approvalType from "@/Mixins/approvalType";

import InfoCreate from "./projectinfo/create";
import InfoInvite from "./projectinfo/createInvite";
import InfoBudget from "./projectinfo/createBudget";
import InfoInviteApproval from "./projectinfo/createInviteApproval";
import InfoContractApproval from "./projectinfo/createContractApproval";
import InfoSeal from "./projectinfo/seal";
import InfoCreatePay from "./projectinfo/createPay";

import FileLink from "@/components/FileLink";
import Role from "@/Mixins/role";

import UserInfo from "@/components/UserInfo";
export default {
  props: ["isShowCloseIcon", "admin"],
  components: {
    // 会议申请
    meetingApply,

    // 供应商准入
    purchaseSupplier,

    // 固定资产
    assetAllot,
    assetHandle,

    // 车辆
    carApplyDetail,

    // 易耗品
    consumableApplyDetail,
    consumablePlanApplyDetail,
    consumableIn,
    consumableUse,
    consumableBack,

    // 通用审批
    commonApply,
    discardApply,
    // 请假审批
    vacationApply,
    transferApply,
    // 考勤未签到
    kqApply,

    // 采购
    purchaseApplyDetail,
    purchaseRecordDetail,
    // 材料仓库
    materialUseDetail,
    materialBackDetail,

    InfoCreate,
    InfoInvite,
    InfoBudget,
    InfoInviteApproval,
    InfoContractApproval,
    InfoSeal,
    InfoCreatePay,

    createMoneyApprovalInfo,
    createMoneyPayApproval,
    createSettlementPayApproval,
    createPayApproval,
    createTechContact,

    createUpdateTime,

    Attachments,

    FileLink,
    UserInfo,
  },
  mixins: [approvalType, Role],
  computed: {
    ...mapState({
      projectTable: (state) => state.main.projectTable,
      isMobile: (state) => state.main.isMobile,
      nowUserData: (state) => state.main.userData,
      approvalSuccess: state => state.main.approvalSuccess,
    }),
  },
  created() {
    if (this.projectTable.status) {
      // 获取审批表详细
      if (this.projectTable.project) {
        this.project = this.projectTable.project;
      }
      this.getProjectApplyInfo(this.projectTable.tableType);
    }

    // if (this.$route.path.toLowerCase().match('/m/')) {
    //   this.isMobile = true
    // }
  },
  data() {
    return {
      baseURL: axios.defaults.baseURL,
      // isMobile: false,

      popHeight: 0,
      formType: 0,

      attachmentArr: [],
      // otherAttachmentArr: [],
      // otherRelateFiles: "",
      userData: [],
      form: "",

      contractList: [],

      teamArr: [],
      projectArr: [],
      sealArr: [],

      // 工程/合同
      project: {},
      // 是否获取到数据
      isHasData: false,

      approvalUserData: [],

      flowId: 0,
      flow: {},

      btnLoading: false,
      btnDisabled: false,
    };
  },
  methods: {
    // 打印格式预览
    printShow() {
      let _type = "";
      // console.log(this.projectTable.tableType)
      switch (this.projectTable.tableType / 1) {
        case 50:
          _type = "materialUse";
          break;
        case 51:
          _type = "materialBack";
          break;
      }
      let _printData = {
        type: _type,
        data: this.form,
        isPrint: true,
      };
      this.$store.commit("set_printData", _printData);
    },
    // 判断是材料需要直接打印的
    isPrint() {
      if (util.isInArray(this.projectTable.tableType, [50, 51])) {
        return true;
      } else {
        return false;
      }
    },

    // 判断是车辆相关申请
    isCarApply() {
      if (
        util.isInArray(this.projectTable.tableType, [
          80,
          81,
          82,
          83,
          84,
          85,
          86,
          87,
          91,
          88,
          89,
          90,
          91,
        ])
      ) {
        return true;
      } else {
        return false;
      }
    },

    // 判断非工程/合同相关审批
    isGc() {
      if (
        util.isInArray(this.projectTable.tableType, [
          50,
          51,
          70,
          71,
          100,
          101,
          102,
          103,
          104,
          60,
          61,
          62,
          63,
          64,
          80,
          81,
          82,
          83,
          84,
          85,
          86,
          87,
          88,
          89,
          90,
          91,
          110,
          111,
          120,
          130,
        ])
      ) {
        return false;
      } else {
        return true;
      }
    },

    // 提醒审批
    FlowRemind() {
      this.btnLoading = true;
      ajax.post(
        "/flow/msg/remind",
        {
          flowId: this.form.flow.id,
        },
        (res) => {
          this.$alert(
            "已经进行审批提醒通知到领导，请耐心等待。切莫恶意催审，谢谢。",
            "提醒成功",
            {
              confirmButtonText: "确定",
            }
          );
          this.btnLoading = false;
          // this.btnDisabled = true
        }
      );
    },

    // 审批表附件type
    getAttachmentsType() {
      // console.log(this.projectTable.tableType)
      switch (this.projectTable.tableType) {
        case "4":
          if (this.project.type == 3 || this.project.type == 4) {
            return 998;
          } else {
            return 4;
          }
          break;
        case "30":
          return 10;
          break;
        case "31":
          return 11;
          break;
        case "32":
          return 14;
          break;
        case "33":
          return 5;
          break;
        case "51":
          return 50;
          break;
        case "2":
        case "4":
        case "10":
        case "11":
        case "5":
        case "14":
        case "40":
        case "50":
          return this.projectTable.tableType;
          break;
        default:
          return 990;
          break;
      }
    },
    // 审批人也支持表格下载
    isApprovalUser(approvalUserData) {
      let _r = false;
      for (let i = 0; i < approvalUserData.length; i++) {
        if (
          approvalUserData[i].user &&
          approvalUserData[i].user.id == this.nowUserData.id
        ) {
          _r = true;
        }
      }
      if (this.admin && this.admin.id == this.nowUserData.id) {
        _r = true;
      }
      return _r;
    },
    arpproval() {
      this.$store.commit('set_approval_row', this.form)
      this.$store.commit("set_approvalId", this.form.flow.curApprovalId);
      this.$store.commit("set_approvalType", 1);
      // this.closeProjectInfo();
    },
    closeProjectInfo() {
      this.$store.commit("set_projectTable", {
        status: false,
        applyId: "",
        tableType: "",
      });
    },
    // 获取审批表详情
    getProjectApplyInfo(type) {
      this.form = "";
      switch (type) {
        // 会议申请
        case "130":
          ajax.get(
            "/conference/apply/info/" + this.projectTable.applyId,
            "",
            (res) => {
              this.isHasData = true;
              this.form = res.vo;
              this.attachmentArr = this.form.attachments
                ? this.form.attachments
                : [];
              this.userData = this.form.flow.creator;
            }
          );
          break;
        // 供应商准入
        case "120":
          ajax.get(
            "/purchase/supplier/apply/info/" + this.projectTable.applyId,
            "",
            (res) => {
              this.isHasData = true;
              this.form = res.vo;
              this.attachmentArr = this.form.attachments
                ? this.form.attachments
                : [];
              this.userData = this.form.flow.creator;
            }
          );
          break;
        // 固定资产
        case "110":
          ajax.get(
            "/asset/handle/apply/info/" + this.projectTable.applyId,
            "",
            (res) => {
              this.isHasData = true;
              this.form = res.vo;
              this.attachmentArr = this.form.attachments
                ? this.form.attachments
                : [];
              this.userData = this.form.flow.creator;
            }
          );
          break;
        case "111":
          ajax.get(
            "/asset/allot/apply/info/" + this.projectTable.applyId,
            "",
            (res) => {
              this.isHasData = true;
              this.form = res.vo;
              this.attachmentArr = this.form.attachments
                ? this.form.attachments
                : [];
              this.userData = this.form.flow.creator;
            }
          );
          break;

        // 车辆相关
        case "80":
        case "81":
        case "82":
        case "83":
        case "84":
        case "85":
        case "86":
        case "87":
        case "88":
        case "89":
        case "90":
        case "91":
          ajax.get(
            "/car/apply/info/" + this.projectTable.applyId,
            "",
            (res) => {
              this.isHasData = true;
              this.form = res.vo;
              this.attachmentArr = this.form.attachments
                ? this.form.attachments
                : [];
              this.userData = this.form.flow.creator;
            }
          );
          break;

        // 请假审批
        case "101":
          ajax.get(
            "/human/leave/apply/info/" + this.projectTable.applyId,
            "",
            (res) => {
              this.isHasData = true;
              this.form = res.vo;
              this.attachmentArr = this.form.attachments
                ? this.form.attachments
                : [];
              this.userData = this.form.flow.creator;
            }
          );
          break;
        // 人员调动审批
        case "102":
          ajax.get(
            "/human/transfer/apply/info/" + this.projectTable.applyId,
            "",
            (res) => {
              this.isHasData = true;
              this.form = res.vo;
              this.attachmentArr = this.form.attachments
                ? this.form.attachments
                : [];
              this.userData = this.form.flow.creator;
            }
          );
          break;
        // 考勤未签到
        case "104":
          ajax.get(
            "/human/kq/apply/info/" + this.projectTable.applyId,
            "",
            (res) => {
              this.isHasData = true;
              this.form = res.vo;
              this.attachmentArr = this.form.attachments
                ? this.form.attachments
                : [];
              this.userData = this.form.flow.creator;
            }
          );
          break;

        // 易耗品
        case "60":
          // 申购
          ajax.get(
            "/consumable/apply/info/" + this.projectTable.applyId,
            "",
            (res) => {
              this.isHasData = true;
              this.form = res.vo;
              this.attachmentArr = this.form.attachments
                ? this.form.attachments
                : [];
              this.userData = this.form.flow.creator;
            }
          );
          break;
        case "61":
          // 采购计划
          ajax.get(
            "/consumable/plan/info/" + this.projectTable.applyId,
            "",
            (res) => {
              this.isHasData = true;
              this.form = res.vo;
              this.attachmentArr = this.form.attachments
                ? this.form.attachments
                : [];
              this.userData = this.form.flow.creator;
            }
          );
          break;
        case "62":
          ajax.get(
            "/consumable/in/info/" + this.projectTable.applyId,
            "",
            (res) => {
              this.isHasData = true;
              this.form = res.vo;
              this.attachmentArr = this.form.attachments
                ? this.form.attachments
                : [];
              this.userData = this.form.flow.creator;
            }
          );
          break;
        case "63":
          ajax.get(
            "/consumable/use/info/" + this.projectTable.applyId,
            "",
            (res) => {
              this.isHasData = true;
              this.form = res.vo;
              this.attachmentArr = this.form.attachments
                ? this.form.attachments
                : [];
              this.userData = this.form.flow.creator;
            }
          );
          break;
        case "64":
          ajax.get(
            "/consumable/back/apply/info/" + this.projectTable.applyId,
            "",
            (res) => {
              this.isHasData = true;
              this.form = res.vo;
              this.attachmentArr = this.form.attachments
                ? this.form.attachments
                : [];
              this.userData = this.form.flow.creator;
            }
          );
          break;

        // 通用审批
        case "100":
          ajax.get(
            "/flow/common/apply/info/" + this.projectTable.applyId,
            "",
            (res) => {
              this.isHasData = true;
              this.form = res.vo;
              this.attachmentArr = this.form.attachments
                ? this.form.attachments
                : [];
              this.userData = this.form.flow.creator;
            }
          );
          break;
        // 废弃审批
        case "103":
          ajax.get(
            "/flow/discard/apply/info/" + this.projectTable.applyId,
            "",
            (res) => {
              this.isHasData = true;
              this.form = res.vo;
              this.attachmentArr = this.form.attachments
                ? this.form.attachments
                : [];
              this.userData = this.form.flow.creator;

              if (this.form.contract.name) {
                this.project = this.form.contract;
              } else if (this.form.project) {
                this.project = this.form.project;
              }
            }
          );
          break;

        // 采购申请/采购备案
        case "70":
          ajax.get(
            "/purchase/apply/info/" + this.projectTable.applyId,
            "",
            (res) => {
              this.isHasData = true;
              this.form = res.vo;
              // 增加以下这行，附件就可以编辑了
              this.flowId = this.form.flow.id;
              this.attachmentArr = this.form.attachments
                ? this.form.attachments
                : [];
              this.userData = this.form.flow.creator;
            }
          );
          ajax.get(
            "/contract/purchase/relate/list",
            {
              purchaseId: this.projectTable.applyId,
            },
            (res) => {
              this.contractList = res.vo.array;
            }
          );
          break;
        case "71":
          ajax.get(
            "/purchase/record/info/" + this.projectTable.applyId,
            "",
            (res) => {
              this.isHasData = true;
              this.form = res.vo;
              // 增加以下这行，附件就可以编辑了
              this.flowId = this.form.flow.id;
              this.attachmentArr = this.form.attachments
                ? this.form.attachments
                : [];
              this.userData = this.form.flow.creator;
            }
          );
          break;

        // 材料仓库
        case "50":
          ajax.get(
            "/storage/material/use/info/" + this.projectTable.applyId,
            "",
            (res) => {
              this.isHasData = true;
              this.form = res.vo;
              this.attachmentArr = this.form.attachments
                ? this.form.attachments
                : [];
              this.userData = this.form.flow.creator;
            }
          );
          break;
        case "51":
          ajax.get(
            "/storage/material/back/apply/info/" + this.projectTable.applyId,
            "",
            (res) => {
              this.isHasData = true;
              this.form = res.vo;
              this.attachmentArr = this.form.attachments
                ? this.form.attachments
                : [];
              this.userData = this.form.flow.creator;
            }
          );
          break;

        // 工程相关
        case "0":
        case "1":
          // 获取项目组
          this.getSeal();
          ajax.get(
            "/seal/apply/info",
            {
              applyId: this.projectTable.applyId,
              type: type,
            },
            (res) => {
              this.form = res.vo;
              this.attachmentArr = this.form.attachments
                ? this.form.attachments
                : [];
              this.userData = this.form.flow.creator;
              this.form.applyType = type;
              this.project = true;
            }
          );
          break;
        case "2":
          // 获取项目组
          this.getTeam();
          // 获取项目列表
          this.getProject();
          ajax.get(
            "/gc/project/apply/info/" + this.projectTable.applyId,
            "",
            (res) => {
              this.form = res.vo;
              this.form.createType = this.form.type;
              this.userData = this.form.flow.creator;
              this.flowId = this.form.flow.id;
              this.attachmentArr = this.form.attachments
                ? this.form.attachments
                : [];

              this.form.iszb = this.form.iszb.toString();
              this.form.name = this.form.project.name;
              this.form.teamId = this.form.project.team
                ? this.form.project.team.id
                : "";
              this.form.level = this.form.project.level;

              if (!this.project) {
                this.project = this.form.project;
              }
              if (this.form.project.father) {
                this.form.parentProjectId = this.form.project.father.id;
              }

              // console.log(this.project)
            }
          );
          break;
        case "4":
          ajax.get(
            "/gc/project/invite/info/" + this.projectTable.applyId,
            "",
            (res) => {
              this.form = res.vo;
              this.form.inviteType = this.form.type;

              console.log(this.form.inviteType);
              this.userData = this.form.flow.creator;
              this.flowId = this.form.flow.id;
              this.attachmentArr = this.form.attachments
                ? this.form.attachments
                : [];
              if (!this.project) {
                this.project = this.form.project;
              }
            }
          );
          break;
        case "13":
          ajax.get(
            "/gc/project/warntime/apply/info/" + this.projectTable.applyId,
            "",
            (res) => {
              console.log(res.vo);
              this.form = res.vo;
              this.userData = this.form.flow.creator;
              this.flowId = this.form.flow.id;
              if (!this.project) {
                this.project = this.form.project;
              }
            }
          );
          break;
        case "10":
        case "30":
          ajax.get(
            "/gc/project/invitesign/info/" + this.projectTable.applyId,
            "",
            (res) => {
              console.log(res.vo);
              this.form = res.vo;
              this.userData = this.form.flow.creator;
              this.flowId = this.form.flow.id;
              this.attachmentArr = this.form.attachments
                ? this.form.attachments
                : [];

              if (!this.project && this.form.project.id) {
                this.project = this.form.project;
              }
              if (this.form.contractVO) {
                this.project = this.form.contractVO;
              }
              console.log(this.project);
            }
          );
          break;
        case "11":
        case "31":
          ajax.get(
            "/gc/project/contractsign/info/" + this.projectTable.applyId,
            "",
            (res) => {
              console.log(res.vo);
              this.form = res.vo;
              this.form.isBigContract = this.form.isBigContract.toString();
              this.form.isBigCustomer = this.form.isBigCustomer.toString();
              this.userData = this.form.flow.creator;
              this.flowId = this.form.flow.id;
              this.attachmentArr = this.form.attachments
                ? this.form.attachments
                : [];
              if (!this.project) {
                this.project = this.form.project;
              }
              if (this.form.contractVO) {
                // 合同项目
                this.project = this.form.contractVO;
              } else {
                // 非合同
                this.project.projectNames = this.project.name;
              }
            }
          );
          break;
        case "5":
        case "33":
          ajax.get(
            "/gc/project/money/approval/info/" + this.projectTable.applyId,
            "",
            (res) => {
              // console.log('money')
              // console.log(res.vo)
              this.form = res.vo;
              this.userData = this.form.flow.creator;
              this.flowId = this.form.flow.id;
              this.attachmentArr = this.form.attachments
                ? this.form.attachments
                : [];
              if (!this.project && this.form.project.id) {
                this.project = this.form.project;
              }
              if (!this.project && this.form.contractVO) {
                this.project = this.form.contractVO;
                this.project.deptName = this.form.contractVO.departmentVO.name;
              }
            }
          );
          break;
        case "14":
        case "32":
        case "40":
          ajax.get(
            "/gc/project/pay/apply/info/" + this.projectTable.applyId,
            "",
            (res) => {
              console.log(res.vo);
              this.form = res.vo;
              this.userData = this.form.flow.creator;
              this.flowId = this.form.flow.id;
              this.flow = this.form.flow;
              this.attachmentArr = this.form.attachments
                ? this.form.attachments
                : [];
              if (!this.project) {
                this.project = this.form.project;
              }

              if (this.form.contractVO) {
                // 合同项目
                this.project = this.form.contractVO;
              } else {
                if (!this.form.isAlone) {
                  // 非合同
                  this.project.projectNames = this.project.name;
                } else {
                  this.project = [];
                }
              }
            }
          );
          break;
        case "9":
          ajax.get(
            "/gc/project/tech/contact/info/" + this.projectTable.applyId,
            "",
            (res) => {
              console.log(res.vo);
              this.form = res.vo;
              this.userData = this.form.flow.creator;
              this.flowId = this.form.flow.id;
              this.attachmentArr = this.form.attachments
                ? this.form.attachments
                : [];
              if (!this.project) {
                this.project = this.form.project;
              }
            }
          );
          break;
      }
    },
    // 获取印章列表
    getSeal() {
      ajax.get(
        "/seal/list",
        {
          depId: this.form.depId,
        },
        (res) => {
          this.sealArr = res.vo.array;
        }
      );
    },
    // 获取项目组
    getTeam() {
      ajax.post("/gc/project/team/list", "", (res) => {
        this.teamArr = res.vo.array;
      });
    },
    // 获取项目列表
    getProject() {
      ajax.get(
        "/gc/project/list",
        {
          depId: "",
        },
        (res) => {
          this.projectArr = res.vo.array;
        }
      );
    },
    // // 汇总更多附件的下载列表 (工程)
    // getOtherAttachmentByProject() {
    //   let _apply = this.otherRelateFiles.applyAttas
    //   let _pay = this.otherRelateFiles.payAttas
    //   let _setup = this.otherRelateFiles.setupAttas
    //   let _ss = this.otherRelateFiles.ssAttas
    //   let _zbht = this.otherRelateFiles.zbhtAttas
    //   this.otherAttachmentArr = _apply.concat(_setup.concat(_zbht.concat(_ss.concat(_pay))))
    // },
    // // 汇总更多附件的下载列表 (合同)
    // getOtherAttachmentByContract() {
    //   let _ht = this.otherRelateFiles.htAttas
    //   let _pay = this.otherRelateFiles.payAttas
    //   let _zb = this.otherRelateFiles.zbAttas
    //   this.otherAttachmentArr = _zb.concat(_ht.concat(_pay))
    // },
  },
  mounted() {
    this.popHeight = document.documentElement.clientHeight - 150;
  },
  watch: {
    // 审批成功后刷新页面
    approvalSuccess() {
      if (this.isMobile) {
        window.location.reload()
      }
    },
    form() {
      if (!this.form) {
        return;
      }
      // console.log(this.form)

      // form.flow.approvals
      this.approvalUserData = [];
      for (var i = 0; i < this.form.flow.approvals.length; i++) {
        if (this.form.flow.approvals[i].user) {
          this.approvalUserData.push(this.form.flow.approvals[i]);
        }
      }

      // // 判断是合同还是工程
      // console.log(this.form)
      // if (this.form.contractVO && !this.form.project) {
      //   // 合同项目
      //   ajax.get("/contract/relate/files/" + this.project.id, "", (res) => {
      //     this.otherRelateFiles = res.vo
      //     this.getOtherAttachmentByContract()
      //   })
      // } else {
      //   // 非合同
      //   ajax.get("/gc/project/relate/files/" + this.form.project.id, "", (res) => {
      //     this.otherRelateFiles = res.vo
      //     this.getOtherAttachmentByProject()
      //   })
      // }
    },
    "projectTable.status"() {
      if (this.projectTable.status) {
        console.log(this.projectTable);
        // 获取审批表详细
        this.project = this.projectTable.project;
        this.getProjectApplyInfo(this.projectTable.tableType);
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/page/user/projectInfo.vue